<template>
  <div class="dialog-feeds">
    <ul class="feeds">
      <li v-if="toDayfeeds.length">
        <FeedBlock :feeds="toDayfeeds" title="Aujourd’hui" />
      </li>
      <li v-if="last7DaysFeeds.length">
        <FeedBlock :feeds="last7DaysFeeds" title="7 derniers jours" />
      </li>
      <li v-if="last30DaysFeeds.length">
        <FeedBlock :feeds="last30DaysFeeds" title="30 derniers jours" />
      </li>
      <li v-if="otherFeeds.length">
        <FeedBlock :feeds="otherFeeds" title="Antérieures" />
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
interface Props {
  toDayfeeds: FeedSchema[];
  last7DaysFeeds: FeedSchema[];
  last30DaysFeeds: FeedSchema[];
  otherFeeds: FeedSchema[];
}
defineProps({
  toDayfeeds: null,
  last7DaysFeeds: null,
  last30DaysFeeds: null,
  otherFeeds: null
});
useAppEventView(EventView.Feed);
</script>
<style lang="scss" scoped>
.dialog-feeds {
  display: flex;
  flex-direction: column;
  gap: var(--gap_l);
  margin-top: var(--gap_l);
  @include above('m') {
    width: 40rem;
  }
}
.feeds {
  display: flex;
  flex-direction: column;
  gap: var(--gap_xl);
}
</style>
